let types: string[] = [];
let components: string[] = [];

export function getTypes(): string[] {
    return types;
}

export function setTypes(newTypes: string[]): void {
    types = newTypes;
}

export function getComponents(): string[] {
    return components;
}

export function setComponents(newComponents: string[]): void {
    components = newComponents;
}
